import { render, staticRenderFns } from "./SaneamentoObjetivo.vue?vue&type=template&id=b6f4e520&"
import script from "./SaneamentoObjetivo.vue?vue&type=script&lang=js&"
export * from "./SaneamentoObjetivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports